import React, { useState } from 'react'
import { Link } from "react-router-dom"
import social_icons from '../../Data/social_icons'
import menu_list from "../../Data/menu_list.json"
import { BsFillArrowRightSquareFill } from "react-icons/bs"
import Logo from "../../logo/autoinsure_favicon.png"

const Footer = () => {
    // State to store email
    const [userEmail, setUserEmail] = useState({
        emailInput: ""
    })

    // Form to handle form event
    const handleFooterForm = (event) => {
        event.preventDefault()
        setUserEmail((prevObject) => {
            return {
                ...prevObject,
                [event.target.name]: event.target.value
            }
        })
    }

  return (
    <>
        <footer className="footer">
            <div className="container footer-container">
                <div className="footer-top">
                    <div className="footer-info-container">
                        <div className="company-logo-container">
                            <img src={Logo} alt="logo"/>
                            <span className='company-logo'>AutoInsure</span>  
                        </div>
                        <div className="footer-icon-container">
                            {social_icons.map((i) => {
                                return (
                                    <div key={i.id} id={i.id} className="icon-capsule">
                                        <Link to={i.link} target="_blank">
                                            {i.icon}
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="footer-links-container">
                        <h2 className="footer-links-title footer-title">Links:</h2>
                        <ul className="footer-list">
                            {menu_list.map((i) => {
                                return (
                                    <li key={i.id} id={i.id} className="footer-list-item">
                                        <Link to={i.link}>
                                            {i.title}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="footer-address-container">
                        <h2 className="footer-address-title footer-title">Address:</h2>
                        <address className="footer-address">
                            17 Britten Street <br/>
                            London <br/>
                            United Kingdom <br/>
                            SW3 3TX
                        </address>
                    </div>
                    <div className="footer-newsletter-container">
                        <h2 className="footer-newsletter-title footer-title">Subscribe</h2>
                        <form onChange={handleFooterForm}>
                            <label htmlFor="" className='footer-subscribe-label'>Subscribe to our email list, below:</label>
                            <div className='footer-subscribe-box'>
                                <input type="email" className='footer-subscribe-input' />
                                <button type='submit' className='footer-subscribe-btn'><BsFillArrowRightSquareFill/></button>
                            </div>
                        </form>
                    </div>
                    <div className="footer-further-container">
                        <h2 className="footer-further-title footer-title">Further Info</h2>
                        <ul className="further-list">
                            <li className="further-item">
                                <Link to="/">
                                    Terms & Conditions
                                </Link>
                            </li>
                            <li className="further-item">
                                <Link to="/">
                                    Privacy Policy
                                </Link>
                            </li>
                            <li className="further-item">
                                <Link to="/">
                                    Subscribe
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="footer-line"></div>
                    <p className="footer-description">© 2023, website made by Eugene Annan. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    </>
  )
}

export default Footer